import { cn } from '@/lib/cn';

/**
 * Confidence as a scored bar with a brand tone. Mint (the "AI-sure" accent) at
 * ≥70, amber in the middle, muted grey when low — low confidence reads as
 * "not yet established", not as an error (that's what danger is for). Single
 * source of truth: every place that shows a confidence score uses this.
 */
export function confidenceTone(value: number): { bar: string; text: string } {
  if (value >= 70) return { bar: 'bg-primary', text: 'text-primary' };
  if (value >= 45) return { bar: 'bg-warning', text: 'text-warning' };
  return { bar: 'bg-fg-subtle', text: 'text-fg-subtle' };
}

export function ConfidenceBar({
  value,
  showLabel = true,
  className,
}: {
  value: number;
  showLabel?: boolean;
  className?: string;
}) {
  const tone = confidenceTone(value);
  return (
    <div className={className}>
      {showLabel && (
        <div className="mb-1 flex items-center justify-between text-xs text-fg-subtle">
          <span>Confidence</span>
          <span className={cn('tabular-nums', tone.text)}>{value}%</span>
        </div>
      )}
      <div className="h-1.5 overflow-hidden rounded-full bg-surface-2">
        <div className={cn('h-full rounded-full transition-[width] duration-500 ease-brand', tone.bar)} style={{ width: `${value}%` }} />
      </div>
    </div>
  );
}
